export const UPDATES_DATA = [
  {
    id: "iso27001",
    title: "ISO 27001:2022 Certification",
    description:
      "Achieved ISO 27001:2022 for robust information security compliance and risk management practices.",
    date: "10/09/2025",
    type: "Certification",
    imgSrc: "Registration.webp", // inside assets/NewUpdates/
    file: "/files/QUANTAROCK SYSTEMS PRIVATE LIMITED 27001 FINAL ICV.pdf",
  },
  {
    id: "iso9001",
    title: "ISO 9001:2015 Certification",
    description:
      "Commitment to consistent quality and customer satisfaction with ISO 9001:2015 certification.",
    date: "16/09/2025",
    type: "Certification",
    imgSrc: "ISO.webp",
    file: "/files/QUANTAROCK SYSTEMS PRIVATE LIMITED QMS.pdf",
  },
  {
    id: "anz_cyber",
    title: "Cyber@ANZ Program",
    description:
      "Completed practical modules in Social Engineering Investigation and Digital Investigation.",
    date: "20/06/2020",
    type: "Team Certificate",
    imgSrc: "anz_certificate.webp",
    file: "/files/anz_cyber_program_completion_certificate.pdf",
  },
  {
    id: "redis_ru330",
    title: "Redis RU330: Redis Security",
    description:
      "Successfully completed Redis University course on Redis Security (RU330).",
    date: "23/09/2022",
    type: "Team Certificate",
    imgSrc: "redis_certificate.webp",
    file: "/files/Vipendra - redislabs RU330 Certificate - Redis University.pdf",
  },
  {
    id: "icsi_cnss",
    title: "ICSI CNSS Certified Network Security Specialist",
    description:
      "Certified Network Security Specialist by ICSI, covering fundamentals of networks and security.",
    date: "03/06/2020",
    type: "Team Certificate",
    imgSrc: "icsi_certificate.webp",
    file: "/files/icsi_network_security_specialist_certificate.pdf",
  },
  {
    id: "skillfront_iso",
    title: "SkillFront ISO/IEC 27001 Associate",
    description:
      "Accredited Professional Certification: ISO/IEC 27001 Information Security Associate from SkillFront.",
    date: "08/03/2023",
    type: "Team Certificate",
    imgSrc: "skillfront_certificate.webp",
    file: "/files/skillfront_iso27001_associate_certificate.pdf",
  },
];

export const ALL_DETAIL_ROUTES_INFO = [...UPDATES_DATA];
